import { QueryHookOptions } from '@apollo/client';
import { CompanySearchQuery, CompanySearchQueryVariables, useCompanySearchQuery } from '../generated/graphql';

const useEateriesQuery = (opts?: QueryHookOptions<CompanySearchQuery, CompanySearchQueryVariables>) =>
    useCompanySearchQuery({
        ...opts,
        variables: {
            ...opts?.variables,
            params: {
                mainCategorySlugs: ['eten-drinken'].concat(opts?.variables?.params?.categorySlugs ?? []),
                ...opts?.variables?.params,
            },
        },
        ssr: !!opts?.ssr,
    });
export default useEateriesQuery;
